import { getemployeeinfo } from "../services/merpservices";


var paidCustArray = [1, 2, 7, 10, 12, 13, 15, 31,48];
var sellerCustArray = [4, 5, 6, 17, 18, 19,22,16,28,29,33,36,39,40,41,44,45,26,14,16,23,32,34,35,38,42,43,46,47,21,27,49,51,52,53,54,55,56];

function srchCustId(arr, obj) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] === obj) return 1;
	}
}
export const getPaidFreeCustFlag = (cust_id) => {
    let Custtype;
    if (srchCustId(paidCustArray, cust_id)) {
        return 1;
    }
    if(srchCustId(sellerCustArray,cust_id)) {
       return 1;
    }
    if(cust_id !== ""){
        if (srchCustId(paidCustArray, cust_id)) {
            Custtype = 1; //paid customer
        }else {
            Custtype = 2; // free customer
        }
        return Custtype;
    }
}

export const customerDetails = (details) =>{
    return details
}


var data =''

export const getempDetails = async (empid, ak) => {
    try {
        const res = await getemployeeinfo(empid, ak);
        const qry_val = res.data;
        data = qry_val
    } catch (error) {
        // Handle error if needed
        console.error(error);
        return null; // Return null or handle error case accordingly
    }
    return data
};
